import * as React from "react";
import CollapsibleHybrid from "./CollapsibleHybrid";
import type { TypeCollapsibleProps } from "./CollapsibleTypes";

/**
 * Collapsible component. Renders the Tailwind (CSS-class) implementation via the
 * Hybrid. Collapsible exposes no styled-system props, so the Hybrid is a thin
 * passthrough to the Tailwind path. The compound `.Trigger` / `.Panel` API is
 * preserved.
 */
const Collapsible = (props: TypeCollapsibleProps) => (
  <CollapsibleHybrid {...props} />
);

Collapsible.Trigger = CollapsibleHybrid.Trigger;
Collapsible.Panel = CollapsibleHybrid.Panel;
Collapsible.displayName = "Collapsible";

export default Collapsible;
